import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { REGEX_PATTERNS } from 'src/app/core/constants/regex-patterns.constant';
import { environment } from 'src/environments/environment';
import { ProfileService } from 'src/app/core/services/profile.service';
import { AdditionalPublicLibraryService } from 'src/app/core/services/additional-public-library.service';
import { SuccessMessageComponent } from 'src/app/components/all-modals/success-message/success-message.component';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { ErrorMessageComponent } from 'src/app/components/all-modals/error-message/error-message.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-add-public-library-modal',
  templateUrl: './add-public-library-modal.component.html',
  styleUrls: ['./add-public-library-modal.component.scss']
})
export class AddPublicLibraryModalComponent implements OnInit {

  publicationType = true;
  additionalLibForm: FormGroup;
  imagePath: any = environment.url;
  isImageError: boolean = false;
  isImageSizeError: boolean = false;
  file: File;
  imgURL: any;
  userCategories = [];
  submitted: boolean = false;
  selectedCity;
  cityList = [];
  dropdownSettings = {
    singleSelection: true,
    text: "Search city",
    enableSearchFilter: true,
    enableFilterSelectAll: false,
    classes: "form-control",
    labelKey: 'name'
  };
  textAreaLength = 0;
  errorMessage = '';
  isError = false;
  address = {
    name: "",
    city: "",
    state: "",
    country: '',
    lat: "",
    long: ""
  };
  isSvgImageError = false;
  imageErrorMsg: string = LITERALS.VALIDATION.IMAGE_VALIDATION;
  errorMessageEmail = '';
  errorMessageName = '';
  @Input() public user;

  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private _profileService: ProfileService,
    private additionalService: AdditionalPublicLibraryService,
    private modalService: NgbModal,
    private _spinner: NgxSpinnerService,
  ) { }

  ngOnInit() {
    // this.loadCategories();
    let date = new Date();
    if (this.user) {
      if (this.user.origin_date)
        date = new Date(this.user.origin_date);
      if (this.user.description)
        this.textAreaLength = this.user.description.length;
      this.additionalLibForm = this.formBuilder.group({
        name: [this.user.business_name, Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.NAME_PATTERN), this.noWhitespaceValidator, Validators.maxLength(45)])],
        email: [this.user.email, Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.EMAIL_PATTERN)])],
        phone: [this.user.phone, Validators.required],
        origin_date: [date, Validators.compose([Validators.required])],
        // category_id: [this.user.category_id, Validators.required],
        // radius: ['', Validators.compose([Validators.min(1), Validators.pattern(REGEX_PATTERNS.INTEGER_PATTERN)])],
        user_outlet_location_attributes: this.formBuilder.group({
          name: this.user.user_outlet_location.name,
          city: this.user.user_outlet_location.city,
          state: this.user.user_outlet_location.state,
          country: this.user.user_outlet_location.country,
          lat: [this.user.user_outlet_location.lat, Validators.required],
          long: [this.user.user_outlet_location.long, Validators.required],
          formatted_address: this.user.user_outlet_location.formatted_address,
          zip_code: this.user.user_outlet_location.zip_code
        }),
        description: [this.user.description, Validators.pattern(REGEX_PATTERNS.TEXT_AREA)]
      });
      if (this.user.avatar)
        this.imgURL = this.imagePath + this.user.avatar;
    } else {
      this.additionalLibForm = this.formBuilder.group({
        name: ['', Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.NAME_PATTERN), this.noWhitespaceValidator, Validators.maxLength(45)])],
        email: ['', Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.EMAIL_PATTERN)])],
        phone: ['', Validators.required],
        origin_date: [date, Validators.compose([Validators.required])],
        // category_id: ['', Validators.required],
        // radius: ['', Validators.compose([Validators.min(1), Validators.pattern(REGEX_PATTERNS.INTEGER_PATTERN)])],
        user_outlet_location_attributes: this.formBuilder.group({
          name: "",
          city: "",
          state: "",
          country: '',
          lat: ["", Validators.required],
          long: ["", Validators.required],
          // lat: [""],
          // long: [""],
          formatted_address: "",
          zip_code: ""
        }),
        description: ['', Validators.pattern(REGEX_PATTERNS.TEXT_AREA)]
      });
    }

    // location_attributes][city]
    // location_attributes][state]
    // location_attributes][name]
    // radius
    // radius_unit
    // avatar: [''],

  }

  loadCategories() {
    this.additionalService.loadCategories().subscribe(
      (response: any) => {
        if (response.success) {
          this.userCategories = response.data.outlet_categories;
        }
      }, (error: any) => {
      });
  }

  closeDialog() {
    this.activeModal.close();
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  toggleView() {
    this.closeDialog();
    this.publicationType = !this.publicationType;
  }

  preview(files) {
    this.isImageError = false;
    this.isImageSizeError = false;
    this.isSvgImageError = false;
    if (files.length === 0)
      return;

    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.isImageError = true;
      // this.toastr.warning('Only images are supported.');
      return;
    }

    if (mimeType !== 'image/png' && mimeType !== 'image/jpeg' && mimeType !== 'image/gif') {
      this.isSvgImageError = true;
      return;
    }

    if (files[0].size >= 5242880) {
      this.isImageSizeError = true;
      return;
    }

    var reader = new FileReader();
    this.imagePath = files;
    this.file = files[0];
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
    }
    this.isImageError = false;
    this.isImageSizeError = false;
  }

  onSubmit() {
    // console.log(this.additionalLibForm);
    this.submitted = true;
    // return;

    if (!this.additionalLibForm.valid) {
      return;
    }
    this._spinner.show();
    // this.errorMessage = '';
    this.errorMessageEmail = '';
    this.errorMessageName = '';
    this.isError = false;
    let params = {
      name: this.additionalLibForm.controls.name.value.trim(),
      email: this.additionalLibForm.controls.email.value,
      phone: this.additionalLibForm.controls.phone.value.number.replace(REGEX_PATTERNS.MOBILE_CLEAN, ''),
      // category_id: this.additionalLibForm.controls.category_id.value,
      origin_date: this.additionalLibForm.controls.origin_date.value,
      description: (this.additionalLibForm.controls.description.value) ? this.additionalLibForm.controls.description.value.trim() : "",
      ico: this.additionalLibForm.controls.phone.value.countryCode.toLowerCase(),
      country_code: this.additionalLibForm.controls.phone.value.dialCode,
      user_outlet_location_attributes: this.additionalLibForm.controls.user_outlet_location_attributes.value,
    };
    if (this.file) {
      params['avatar'] = this.file;
    }

    let subscriber;
    if (this.user) {
      subscriber = this.additionalService.editAdditionalPublicLibrary(params, this.user.id);
    } else {
      subscriber = this.additionalService.createAdditionalPublicLibrary(params);
    }

    subscriber.subscribe(
      (response: any) => {
        this._spinner.hide();
        if (response.success) {
          this.activeModal.close('success');
          const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          if (this.user)
            modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.ADDITIONAL_PUBLIC_LIB_UPDATED;
          else
            modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.ADDITIONAL_PUBLIC_LIB_ADDED;
        } else if (response.errors instanceof Array && response.errors.length > 0) {
            response.errors.forEach(element => {
              if ((element['field'] == 'email' && element['detail'] == 'has already been taken') || response.errors.includes('Email has already been taken')) {
                this.errorMessageEmail = 'Email is already taken, please enter a different email';
                this.isError = true;
              }
              if ((element['field'] == 'name' && element['detail'] == 'has already been taken') || response.errors.includes('Name has already been taken')) {
                this.errorMessageName = 'Name is already taken, please enter a different name';
                this.isError = true;
              }
            });
        } else if (response.errors == "You can't create user outlet with this email. already use for user." || response.errors == 'Email is already taken, please enter different email') {
          this.errorMessageEmail = 'Email is already taken, please enter a different email';
        } else {
          const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modelRef.componentInstance.message = response.errors;
        }
      }, (error: any) => {
        this._spinner.hide();
      });

  }

  textAreaAdjust(event) {
    this.textAreaLength = event.target.value.length;
  }
  trimControl(control) {
    if (this.additionalLibForm.get(control).value) {
      this.additionalLibForm.get(control).setValue(this.additionalLibForm.get(control).value.trim())
    }
  }

  restrictNumeric(event) {
    //firefox solution
    event = event || window.event;
    var charCode = (typeof event.which == "undefined") ? event.keyCode : event.which;
    var charStr = String.fromCharCode(charCode);

    if (!charStr.match(/^[0-9/]+$/))
      event.preventDefault();
    const restrictKeycodes = [101, 46, 43, 45];
    if (restrictKeycodes.includes(event.keyCode) || event.target.value.length > 11) {
      return false;
    }
  }

  preventInput(event) {
    event.preventDefault();
  }

  restrictNumericPaste(event) {
    let text = event.clipboardData.getData('text').toString();
    let filteredText = text.replace(REGEX_PATTERNS.NUMBER_REMOVE_DATE, "");
    // this.editProfileForm.controls.birth_date.setValue(filteredText);
    event.target.value = filteredText;
    event.preventDefault();
  }


}
